import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpCookieService {
  /**
   * Returns the value of a cookie by name, or null if not found.
   */
  getCookie(name: string): string | null {
    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
      const [cookieName, ...rest] = cookie.trim().split('=');
      if (cookieName === name) {
        return decodeURIComponent(rest.join('='));
      }
    }

    return null;
  }
}

